import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('mbway', app)
  return store
}
